import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host {
      display: inline-flex;
    }

    /* ── Base ────────────────────────────────────────────────────────────────── */
    .uwc-tag {
      /* private tokens — overridden by severity modifiers */
      --_bg:     var(--uwc-tag-primary-bg,    #ede9fe);
      --_color:  var(--uwc-tag-primary-color,  #4f46e5);
      --_border: var(--uwc-tag-primary-border, #c4b5fd);

      display: inline-flex;
      align-items: center;
      gap: ${t.space1};
      /* em-based height tracks the tag font so it scales with the size presets */
      height: 1.85em;
      padding: 0 ${t.space2};
      font-size: var(--uwc-tag-font-size, ${t.fontSizeSm});
      font-weight: var(--uwc-tag-font-weight, ${t.fontWeightSemibold});
      white-space: nowrap;
      border-radius: var(--uwc-tag-radius, ${t.radiusSm});
      border: 1px solid transparent;
      background: var(--_bg);
      color: var(--_color);
    }

    /* ── Severity modifiers ─────────────────────────────────────────────────── */
    .uwc-tag--success {
      --_bg:     var(--uwc-tag-success-bg,     #dcfce7);
      --_color:  var(--uwc-tag-success-color,   #15803d);
      --_border: var(--uwc-tag-success-border,  #86efac);
    }

    .uwc-tag--info {
      --_bg:     var(--uwc-tag-info-bg,     #e0f2fe);
      --_color:  var(--uwc-tag-info-color,   #0369a1);
      --_border: var(--uwc-tag-info-border,  #7dd3fc);
    }

    .uwc-tag--warning {
      --_bg:     var(--uwc-tag-warning-bg,     #fef9c3);
      --_color:  var(--uwc-tag-warning-color,   #92400e);
      --_border: var(--uwc-tag-warning-border,  #fde047);
    }

    .uwc-tag--danger {
      --_bg:     var(--uwc-tag-danger-bg,     #fee2e2);
      --_color:  var(--uwc-tag-danger-color,   #b91c1c);
      --_border: var(--uwc-tag-danger-border,  #fca5a5);
    }

    .uwc-tag--secondary {
      --_bg:     var(--uwc-tag-secondary-bg,     #e2e8f0);
      --_color:  var(--uwc-tag-secondary-color,   #475569);
      --_border: var(--uwc-tag-secondary-border,  #cbd5e1);
    }

    .uwc-tag--contrast {
      --_bg:     var(--uwc-tag-contrast-bg,     #1e293b);
      --_color:  var(--uwc-tag-contrast-color,   #f8fafc);
      --_border: var(--uwc-tag-contrast-border,  #334155);
    }

    /* ── Outlined variant ───────────────────────────────────────────────────── */
    .uwc-tag--outlined {
      background: transparent;
      color: var(--_color);
      border-color: var(--_color);
    }

    /* ── Sizes (em-based height tracks font-size, so it scales too) ──────────── */
    :host([size="small"]) .uwc-tag { font-size: var(--uwc-tag-font-size, ${t.fontSizeXs}); }
    :host([size="large"]) .uwc-tag { font-size: var(--uwc-tag-font-size, ${t.fontSizeMd}); }

    /* ── Rounded ────────────────────────────────────────────────────────────── */
    :host([rounded]) .uwc-tag {
      border-radius: var(--uwc-radius-full, ${t.radiusFull});
    }

    /* ── Icon ───────────────────────────────────────────────────────────────── */
    .uwc-tag__icon {
      display: inline-flex;
      flex-shrink: 0;
    }
  `,
];
